export const ENERGI_TESTNET = {
  id: 49797,
  name: 'Energi',
  network: 'energi',
  nativeCurrency: {
    name: 'Energi',
    symbol: 'NRG',
    decimals: 18,
  },
  rpcUrls: {
    public: { http: ['https://nodeapi.test.energi.network'] },
    default: { http: ['https://nodeapi.test.energi.network'] },
  },
  blockExplorers: {
    etherscan: { name: 'Energi explorer', url: 'https://explorer.test.energi.network' },
    default: { name: 'Energi explorer', url: 'https://explorer.test.energi.network' },
  },
  contracts: {
    multicall3: {
      address: '0x9510e36CAe130B28184B1aD3852FE5F67193c341',
      blockCreated: 2_441_944,
    },
  },
};

export const ENERGI_MAINNET = {
  id: 39797,
  name: 'Energi',
  network: 'energi',
  nativeCurrency: {
    name: 'Energi',
    symbol: 'NRG',
    decimals: 18,
  },
  rpcUrls: {
    public: { http: ['https://nodeapi.energi.network'] },
    default: { http: ['https://nodeapi.energi.network'] },
  },
  blockExplorers: {
    etherscan: { name: 'Energi explorer', url: 'https://explorer.energi.network' },
    default: { name: 'Energi explorer', url: 'https://explorer.energi.network' },
  },
  contracts: {},
};

export const BASECHAIN_MAINNET = {
  id: 8453,
  name: 'Base',
  network: 'base',
  nativeCurrency: {
    name: 'Base',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    public: { http: ['https://mainnet.base.org'] },
    default: { http: ['https://mainnet.base.org'] },
  },
  blockExplorers: {
    etherscan: { name: 'Basescan', url: 'https://basescan.org' },
    default: { name: 'Basescan', url: 'https://basescan.org' },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 5022,
    },
  },
};

export const BASECHAIN_TESTNET = {
  id: 84532,
  name: 'Base Sepolia',
  network: 'base-sepolia',
  nativeCurrency: {
    name: 'Base',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    public: { http: ['https://sepolia.base.org'] },
    default: { http: ['https://sepolia.base.org'] },
  },
  blockExplorers: {
    etherscan: { name: 'Basescan Testnet', url: 'https://sepolia.basescan.org' },
    default: { name: 'Basescan Testnet', url: 'https://sepolia.basescan.org' },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 4986231,
    },
  },
};

export const SONEIUM_MAINNET = {
  id: 1868,
  name: 'Soneium',
  network: 'soneium',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    public: { http: ['https://soneium.drpc.org'] },
    default: { http: ['https://soneium.drpc.org'] },
  },
  blockExplorers: {
    etherscan: { name: 'Soneium explorer', url: 'https://soneium.blockscout.com' },
    default: { name: 'Soneium explorer', url: 'https://soneium.blockscout.com' },
  },
  contracts: {},
};

export const SONEIUM_TESTNET = {
  id: 1946,
  name: 'Soneium Minato',
  network: 'soneium-testnet',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    public: { http: ['https://soneium-minato.drpc.org'] },
    default: { http: ['https://soneium-minato.drpc.org'] },
  },
  blockExplorers: {
    etherscan: { name: 'Soneium Minato explorer', url: 'https://soneium-minato.blockscout.com' },
    default: { name: 'Soneium Minato explorer', url: 'https://soneium-minato.blockscout.com' },
  },
  contracts: {},
};

export const NETWORK_RPC_URLS = {
  1: 'https://ethereum.energi.network',
  5: 'https://ethereum.test.energi.network',
  39797: 'https://nodeapi.energi.network',
  49797: 'https://nodeapi.test.energi.network',
  8453: 'https://mainnet.base.org',
  84532: 'https://sepolia.base.org',
  33139: 'https://apechain.calderachain.xyz/http',
  33111: 'https://curtis.rpc.caldera.xyz/http',
  80069: 'https://bepolia.rpc.berachain.com/',
  80094: 'https://rpc.berachain.com/',
  1868: 'https://soneium.drpc.org',
  1946: 'https://soneium-minato.drpc.org',
  2741: 'https://api.mainnet.abs.xyz',
  11124: 'https://api.testnet.abs.xyz',
  109: 'https://shibrpc.com', // Shibarium Mainnet
  157: 'https://puppynet.shibrpc.com', // Puppynet (Shibarium Testnet)
  443: 'https://testnet.ten.xyz/v1/?token=0xDBD075357B2F2A34DFD743007E42CF069786A70F', // TEN Testnet
  10143: 'https://testnet-rpc.monad.xyz', // Monad Testnet
};

export const ABSTRACT_MAINNET = {
  id: 2741,
  name: 'Abstract',
  network: 'abstract',
  nativeCurrency: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    public: { http: ['https://api.mainnet.abs.xyz'] },
    default: { http: ['https://api.mainnet.abs.xyz'] },
  },
  blockExplorers: {
    etherscan: { name: 'Abstract explorer', url: 'https://abscan.org' },
    default: { name: 'Abstract explorer', url: 'https://abscan.org' },
  },
  contracts: {},
};

export const ABSTRACT_TESTNET = {
  id: 11124,
  name: 'Abstract Testnet',
  network: 'abstract-testnet',
  nativeCurrency: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    public: { http: ['https://api.testnet.abs.xyz'] },
    default: { http: ['https://api.testnet.abs.xyz'] },
  },
  blockExplorers: {
    etherscan: { name: 'Abstract Testnet explorer', url: 'https://sepolia.abscan.org' },
    default: { name: 'Abstract Testnet explorer', url: 'https://sepolia.abscan.org' },
  },
  contracts: {},
};

export const SHIBARIUM_MAINNET = {
  id: 109,
  name: 'Shibarium',
  network: 'shibarium',
  nativeCurrency: {
    name: 'BONE',
    symbol: 'BONE',
    decimals: 18,
  },
  rpcUrls: {
    public: { http: ['https://shibrpc.com'] },
    default: { http: ['https://shibrpc.com'] },
  },
  blockExplorers: {
    etherscan: { name: 'Shibariumscan', url: 'https://shibariumscan.io' },
    default: { name: 'Shibariumscan', url: 'https://shibariumscan.io' },
  },
  contracts: {},
};

export const SHIBARIUM_TESTNET = {
  id: 157,
  name: 'Puppynet',
  network: 'puppynet',
  nativeCurrency: {
    name: 'BONE',
    symbol: 'BONE',
    decimals: 18,
  },
  rpcUrls: {
    public: { http: ['https://puppynet.shibrpc.com'] },
    default: { http: ['https://puppynet.shibrpc.com'] },
  },
  blockExplorers: {
    etherscan: { name: 'Puppyscan', url: 'https://puppyscan.shib.io' },
    default: { name: 'Puppyscan', url: 'https://puppyscan.shib.io' },
  },
  contracts: {},
};

export const TEN_TESTNET = {
  id: 443,
  name: 'TEN Testnet',
  network: 'ten-testnet',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    public: {
      http: ['https://testnet.ten.xyz/v1/?token=0xDBD075357B2F2A34DFD743007E42CF069786A70F'],
    },
    default: {
      http: ['https://testnet.ten.xyz/v1/?token=0xDBD075357B2F2A34DFD743007E42CF069786A70F'],
    },
  },
  blockExplorers: {
    etherscan: { name: 'TEN Scan', url: 'https://tenscan.io' },
    default: { name: 'TEN Scan', url: 'https://tenscan.io' },
  },
  contracts: {},
};

// TODO: Add TEN mainnet configuration when available
// export const TEN_MAINNET = {
//   id: [MAINNET_CHAIN_ID],
//   name: 'TEN',
//   network: 'ten',
//   nativeCurrency: {
//     name: 'Ether',
//     symbol: 'ETH',
//     decimals: 18,
//   },
//   rpcUrls: {
//     public: { http: ['[MAINNET_RPC_URL]'] },
//     default: { http: ['[MAINNET_RPC_URL]'] },
//   },
//   blockExplorers: {
//     etherscan: { name: 'TEN Scan', url: '[MAINNET_EXPLORER_URL]' },
//     default: { name: 'TEN Scan', url: '[MAINNET_EXPLORER_URL]' },
//   },
//   contracts: {},
// };
